import { faCartShopping } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from 'react'


const CartIcon = props => {
    return (
        <FontAwesomeIcon icon={faCartShopping}/>    
    );
};

export default CartIcon;